import {
  Box,
  Button,
  InputLabel,
  Paper,
  Toolbar,
  Typography,
  Divider,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import CustomDialog from "../../components/common/Dialog/CustomDialog";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { changePassword } from "../../services/authService";
import { getUserDetails } from "../../services/userService";
import "./styles.scss";

const MyProfile = () => {
  const { firstName, lastName, email, id, clientInfo } = useSelector(
    (state: RootState) => state.userDetails
  );
  const [userClientInfo, setUserClientInfo] = useState(clientInfo || []);

  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (id) {
      getUserDetails(id)
        .then((res) => {
          if (res?.clientInfo) {
            setUserClientInfo(res.clientInfo);
          }
        })
        .catch((err) => {
          console.log("Error fetching user details:", err);
        });
    }
  }, [id]);

  const handleClose = () => {
    setError("");
    setOpen(false);
    setIsLoading(false);
    setIsSuccess(false);
  };

  const handleSendLink = () => {
    setError("");
    setIsLoading(true);
    changePassword()
      .then(() => {
        setIsLoading(false);
        setIsSuccess(true);
      })
      .catch(() => {
        setError("Something went wrong!! Please try again");
        setIsLoading(false);
      });
  };

  return (
    <>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          margin: "0px 15px",
          width: "79%",
        }}
      >
        <Typography className="profile-title">My Profile</Typography>
      </Toolbar>
      <Paper className="profile-container">
        <Box className="profile-section">
          <Box className="field-data">
            <InputLabel className="label">Name</InputLabel>
            <Typography className="data">{`${firstName ?? ""}${
              firstName && lastName && " "
            }${lastName ?? ""}`}</Typography>
          </Box>
          <Box className="field-data">
            <InputLabel className="label">Email</InputLabel>
            <Typography className="data">{email ?? ""}</Typography>
          </Box>
          <Button
            variant="contained"
            className="change-password"
            onClick={() => setOpen(true)}
          >
            Change Password
          </Button>
        </Box>
        
        {userClientInfo && userClientInfo.length > 0 && (
          <>
            <Divider sx={{ my: 3 }} />
            <Box className="client-info-section">
              <Typography className="client-info-title">
                Client Information
              </Typography>
              {userClientInfo.map((client, index) => (
                <Box key={index} className="client-card">
                  <Typography className="client-organization-name">
                    {client.organizationName}
                  </Typography>
                  <Box className="client-details-grid">
                    <Box className="field-data">
                      <InputLabel className="label">Tax Number</InputLabel>
                      <Typography className="data">
                        {client.taxNumberMasked}
                      </Typography>
                    </Box>
                    <Box className="field-data">
                      <InputLabel className="label">Address</InputLabel>
                      <Typography className="data">
                        {[
                          client.address,
                          client.apartment,
                          client.city,
                          client.state,
                          client.zip,
                          client.country,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </Typography>
                    </Box>
                    <Box className="field-data">
                      <InputLabel className="label">Office Phone</InputLabel>
                      <Typography className="data">
                        {client.officePhone || "N/A"}
                      </Typography>
                    </Box>
                    <Box className="field-data">
                      <InputLabel className="label">Home Phone</InputLabel>
                      <Typography className="data">
                        {client.homePhone || "N/A"}
                      </Typography>
                    </Box>
                    <Box className="field-data">
                      <InputLabel className="label">Mobile Phone</InputLabel>
                      <Typography className="data">
                        {client.mobilePhone || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </>
        )}
      </Paper>
      <CustomDialog
        dialogContent={
          isSuccess
            ? `We sent a password reset link to ${email}`
            : `To reset your password, we’ll send a reset link to ${email}`
        }
        title={isSuccess ? "Link Sent!" : "Reset Password"}
        handleClose={handleClose}
        open={open}
        primaryBtnText={isSuccess ? "CLOSE" : "SEND LINK"}
        secondaryBtnText={isSuccess ? "" : "CANCEL"}
        primaryBtnAction={isSuccess ? handleClose : handleSendLink}
        secondaryBtnAction={handleClose}
        primaryBtnLoading={isLoading}
        error={error}
      />
    </>
  );
};

export default MyProfile;
